import connectNotifications from "@zendesk/knowledge-redux/lib/connectors/connectNotifications";
import Notifications from "@zendesk/knowledge-components/lib/Notifications";

export default connectNotifications(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notifications/index.js